import React, { useEffect, useState } from "react";
import { useAuth } from "../../auth/FirebaseAuth.js";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";

import Space from "../../layout/Space.js";

import SecondaryButton from "../../buttons/SecondaryButton.js";

import PrimaryButton from "../../buttons/PrimaryButton.js";
import ExpertsAM from "../../actionmenus/ExpertsAM.js";
import { Skeleton, Switch } from "@mui/material";
import {
  getArrayDocDataByID,
  getArrayDocDataByRef,
  getDateFromFlutter,
  getDocDataByRef,
  queryCollection,
  updateDocDataField,
} from "../../models/DataFunctions.js";
import Modal1 from "../../modals/Modal1.js";
import { useAppContext } from "../../config/AppContext.js";
import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken.js";
import stripeSetupSession from "../../api/stripe/stripeSetupSession.js";
import SuperModal from "../../modals/SuperModal.js";
import { useSnackbar } from "notistack";
import updateDocDataFieldApi from "../../api/database/updateDocDataFieldApi.js";
import {
  BusinessBar,
  EngagementBar,
  ForeverBar,
  PremiumBar,
  StarterBar,
} from "../../hexagone/ParametersNavBar.js";
import DropDownGPT1 from "../../dropdowns/DropDownGPT1.js";
import DropDownGPT0 from "../../dropdowns/DropDownGTP0.js";
import PlanMarket from "../../modals/PlanMarket.js";
import SignMarket, { formatCentime } from "../../modals/SignMarket.js";
import stripeGetPaymentMethod from "../../api/stripe/stripeGetPaymentMethod.js";
import stripeCheckoutSession from "../../api/stripe/stripeCheckoutSession.js";
import { Spin } from "antd";
import downloadFile from "../../api/download/downloadFile.js";
import getFactureHexagoneUrls from "../../api/presigned/getFactureHexagoneUrls.js";
import SmallSpinner from "../../loading/SmallSpinner.js";
import {
  EasySwitch,
  SettingsBrick,
  TogglePlanBrick,
  ToggleSettingsBrick,
} from "../../textfields/EasySwitch.js";
import ConfettiExplosion from "react-confetti-explosion";
import TabGPT from "../../tabs/TabGPT.js";
import Gleap from "gleap";
import { FolderTypeIcon } from "../folder_pages/FolderHelpers.js";
import Icon1 from "../../icons/Icon.js";

function Facturation({ userData, orgData, navigateWorkspace, workspaceData }) {
  const { currentUser, loading } = useAuth();
  const [no_plan, setNoPlan] = useState(
    orgData.facturation?.plan + orgData.facturation?.engagement
  );
  const [congratulations, setCongratulations] = useState(false);
  const [members, setMembers] = useState([]);
  const [app_users, setAppUsers] = useState([]);
  const [searchParams] = useSearchParams();
  const upgrade = searchParams.get("upgrade");
  const [factures_hexagone, setFacturesHexagone] = useState([]);
  const [loadingData, setLoadingData] = useState(false);
  const [displayPlanMessage, setDisplayPlanMessage] = useState(false);

  const [tabs, setTabs] = useState([
    { id: "subscription", label: "Abonnements" },
    { id: "professions", label: "Briques métiers" },
    { id: "factures", label: "Factures" },
    { id: "storage", label: "Stockage" },
  ]);
  const [activeTab, setActiveTab] = useState("subscription");

  const [thresholds, setThresholds] = useState([
    {
      label: "10 signatures",
      value: 10,
    },
    {
      label: "20 signatures",
      value: 20,
    },
    {
      label: "30 signatures",
      value: 30,
    },
  ]);

  const [signpacks, setSignpacks] = useState([
    {
      label: "10 signatures",
      value: 10,
    },
    {
      label: "20 signatures",
      value: 20,
    },
    {
      label: "50 signatures",
      value: 50,
    },
    {
      label: "100 signatures",
      value: 100,
    },
  ]);
  const location = useLocation();
  const [modalOpen, setModalOpen] = useState(upgrade === "true");
  const [modal_name, setModalName] = useState(
    upgrade === "true" ? "plan_market" : ""
  );

  useEffect(() => {
    if (upgrade === "true") {
      setModalOpen(true);
      setModalName("plan_market");
    }
  }, [upgrade, location]);

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const handleSubscription = () => {
    setModalName("plan_market");
    setModalOpen(true);
  };

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  const handlePaymentMethod = async () => {
    const token = await getOrRefreshFirebaseToken();
    const url = await stripeSetupSession(token, prefix);
    if (url) {
      window.open(url, "_blank");
    }
  };

  const handleAddSignature = () => {
    setModalName("sign_market");
    setModalOpen(true);
  };
  // Fetch user, org, clients, and article data
  const handleFetchData = async () => {
    setLoadingData(true);
    if (userData) {
      try {
        if (orgData.facturation?.stripe_client_id) {
          const token = await getOrRefreshFirebaseToken();
          let res = await stripeGetPaymentMethod(token, prefix);
          await updateDocDataFieldApi(
            orgData.ref,
            "facturation.payment_method",
            res.payment_method,
            prefix
          );
        }
        const members = await getArrayDocDataByID("user", orgData.users_id);
        const app_users =
          (await getArrayDocDataByID(
            "user",
            orgData.appareils_users_id || []
          )) || [];

        setMembers(members);
        setAppUsers(app_users);

        const facture_filters = [
          {
            field: "master_id",
            operator: "==",
            value: orgData.id,
          },
        ];
        let factures_hexagone = await queryCollection(
          "facture_hexagone",
          facture_filters
        );

        setFacturesHexagone(factures_hexagone);

        // Update state with fetched data
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
    setLoadingData(false);
  };

  const handleUpdatePlans = async (plan, checked) => {
    let plans = orgData.facturation.plans || [];
    if (checked) {
      if (!plans.includes(plan)) {
        plans.push(plan);
      }
    } else {
      if (plans.includes(plan)) {
        plans = plans.filter((p) => p !== plan);
      }
    }
    await updateDocDataFieldApi(
      orgData.ref,
      "facturation.plans",
      plans,
      prefix
    );
    handleClickVariant("Mise à jour du plan", "success");
  };

  const handleChangePlan = async (plan, checked) => {
    let final_plan = "free";
    if (checked) {
      await updateDocDataFieldApi(
        orgData.ref,
        "facturation.plan",
        plan,
        prefix
      );
    } else {
      if (plan === "expert") {
        final_plan = "premium";
      } else if (plan === "premium") {
        final_plan = "basic";
      } else {
        final_plan = "free";
      }
      await updateDocDataFieldApi(
        orgData.ref,
        "facturation.plan",
        final_plan,
        prefix
      );
    }

    handleClickVariant("Mise à jour du plan", "success");
  };

  const [loadingOpenFacture, setLoadingOpenFacture] = useState(false);
  const handleOpenFacture = async (facture) => {
    setLoadingOpenFacture(true);
    const token = await getOrRefreshFirebaseToken();
    await getFactureHexagoneUrls(facture.id, token, prefix);
    let new_facture = await getDocDataByRef(facture.ref);
    window.open(new_facture.file.url, "_blank");
    handleClickVariant("Ouverture de la facture", "success");
    setLoadingOpenFacture(false);
  };

  useEffect(() => {
    if (orgData) {
      if (
        !workspaceData &&
        orgData.facturation?.plan + orgData.facturation?.engagement != no_plan
      ) {
        setNoPlan(orgData.facturation?.plan + orgData.facturation?.engagement);
        setCongratulations(true);
        setModalOpen(false);
        handleClickVariant(
          "Félicitations, vous avez changé de plan",
          "success"
        );
        setModalName("");

        setTimeout(() => {
          setCongratulations(false);
        }, 4000);
      }
      handleFetchData();
    }
  }, [orgData]);

  if (loading || !currentUser || !userData) {
    return (
      <div className="w-full h-full overflow-auto flex flex-row gap-2 mt-3">
        {/* Left Column Skeleton */}
        <Space y={20} />
        <div className="h-full flex-grow pl-4 flex flex-col gap-2 max-w-c1p2k">
          {/* Skeleton for the title and buttons */}
          <div className="flex flex-row w-full justify-between">
            <Skeleton variant="rounded" width={100} height={25} />

            <div className="flex flex-row gap-2">
              <Skeleton variant="rounded" width={100} height={25} />
              <Skeleton variant="rounded" width={100} height={25} />
            </div>
          </div>
          <Skeleton variant="rounded" width={200} height={30} />
          <Skeleton variant="rounded" width={100} height={25} />
          <Space y={10} />
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col w-full max-h-full h-full pb-20 pl-4 overflow-y-auto">
      {displayPlanMessage && (
        <div className="fixed flex flex-col bg-shadow_10 items-center justify-center top-0 left-0 w-screen h-screen z-50 ">
          <div className="flex flex-col w-c300 gap-2 bg-white z-50 p-4 shadow-lg rounded-xl">
            <div className="text-h3 text-shadow_50 ">
              Pour changer de plan, veuillez contacter notre équipe
            </div>{" "}
            <div className="text-h3 text-shadow_50 ">
              William Bressollette - 06 51 02 24 62
            </div>{" "}
            <div className="flex flex-row gap-2 justify-end mt-2">
              <SecondaryButton onClick={() => setDisplayPlanMessage(false)}>
                Fermer
              </SecondaryButton>
              <PrimaryButton onClick={() => Gleap.startConversation()}>
                Utiliser le chat
              </PrimaryButton>
            </div>{" "}
          </div>
        </div>
      )}
      <div className="flex flex-col w-full h-fit ">
        {modal_name === "plan_market" && (
          <Modal1 isOpen={modalOpen} onClose={() => {}}>
            <PlanMarket onClose={() => setModalOpen(false)}></PlanMarket>
          </Modal1>
        )}
        {modal_name === "sign_market" && (
          <Modal1 isOpen={modalOpen} onClose={() => setModalOpen(false)}>
            <SignMarket onClose={() => setModalOpen(false)}></SignMarket>
          </Modal1>
        )}
        <div className="text-h1 font-bold text-left">Facturation</div>
        {orgData.facturation?.test_account && (
          <div className="text-h3 my-4 text-red-500 font-bold">
            COMPTE DE TEST - Aucune action n'est possible
          </div>
        )}
        {!userData.org_admin && (
          <>
            <Space y={10} />
            <div className="text-h3 text-shadow_50 font-bold">
              Seul un administrateur peut accéder à cette page.
            </div>
          </>
        )}{" "}
        <Space y={5} />
        {userData.org_admin && (
          <>
            <TabGPT
              tabs={tabs}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
            ></TabGPT>
            <Space y={20} />
            {activeTab === "subscription" && (
              <>
                <SettingsBrick
                  title={"Moyen de paiement"}
                  description={
                    "Gérez votre moyen de paiement. (Carte bancaire) pour les frais de service sur les paiements particuliers."
                  }
                >
                  <div className="flex flex-col gap-2">
                    {(orgData.facturation?.payment_method === null ||
                      orgData.facturation?.payment_method === "") && (
                      <div className="text-h3 text-red-500 font-medium">
                        Votre moyen de paiement n'est pas renseigné.
                      </div>
                    )}
                    <div className="flex flex-row gap-2">
                      {orgData.facturation?.payment_method && (
                        <div className=" rounded-md py-0.5 text-shadow_50 bg-indigo-50 border-l-2 border-indigo-500 px-2 text-h2 font-semibold w-fit">
                          {orgData.facturation?.payment_method}
                        </div>
                      )}
                      {orgData.facturation?.payment_method ? (
                        <SecondaryButton
                          onClick={handlePaymentMethod}
                          className="w-fit"
                          disabled={orgData.facturation?.test_account === true}
                        >
                          Modifier le moyen de paiement
                        </SecondaryButton>
                      ) : (
                        <PrimaryButton
                          onClick={handlePaymentMethod}
                          className="w-fit"
                          disabled={orgData.facturation?.test_account === true}
                        >
                          Ajouter un moyen de paiement
                        </PrimaryButton>
                      )}
                    </div>{" "}
                  </div>
                </SettingsBrick>
                <div>
                  <SettingsBrick
                    title={"Abonnement"}
                    description={
                      "Gérez votre abonnement et vos fonctionnalités."
                    }
                  >
                    {congratulations && <ConfettiExplosion />}
                    <div className="flex flex-row gap-2">
                      {orgData.facturation?.plan === "premium" && (
                        <PremiumBar></PremiumBar>
                      )}
                      {orgData.facturation?.plan === "business" && (
                        <BusinessBar></BusinessBar>
                      )}
                      {orgData.facturation?.plan === "starter" && (
                        <StarterBar></StarterBar>
                      )}{" "}
                      {orgData.facturation?.engagement && (
                        <EngagementBar
                          engagement={orgData.facturation?.engagement}
                        ></EngagementBar>
                      )}
                      <PrimaryButton
                        disabled={
                          orgData.facturation?.test_account === true ||
                          orgData.facturation?.engagement === "forever"
                        }
                        onClick={handleSubscription}
                        className="w-fit"
                      >
                        {["premium", "business", "starter"].includes(
                          orgData.facturation?.plan
                        )
                          ? " Gérer l'abonnement"
                          : "Souscrire à un abonnement"}
                      </PrimaryButton>
                    </div>
                  </SettingsBrick>
                </div>
                <div className="flex flex-col  mt-8">
                  <TogglePlanBrick
                    icon_name="hexagone-light"
                    title="Invité sur hexagone"
                    className=" border-l-3 border-indigo-200 border via-transparent to-transparent"
                    checked={orgData.facturation.plan === "free"}
                    disabled={!userData.admin}
                    onChange={(checked) =>
                      userData.admin
                        ? handleChangePlan("free", checked)
                        : setDisplayPlanMessage(true)
                    }
                    description={
                      "Accédez aux fonctionnalités light de hexagone (gestion des dossiers, gestion des utilisateurs, dépendant de l'entreprise qui vous invite)"
                    }
                    price="gratuit"
                  ></TogglePlanBrick>
                  <TogglePlanBrick
                    icon_name="hexagone-basique"
                    checked={["basic", "premium", "expert"].includes(
                      orgData.facturation.plan
                    )}
                    className=" border-l-3 border-gray-400 border via-transparent to-transparent"
                    title="Fonctionnalités de base"
                    onChange={(checked) =>
                      userData.admin
                        ? handleChangePlan("basic", checked)
                        : setDisplayPlanMessage(true)
                    }
                    description={
                      "Accédez aux fonctionnalités de base de hexagone (invitations des clients et partenaires, gestion des dossiers, signature électronique, paiement particulier par virement, gestion des devis, gestion des utilisateurs, gestion des articles, gestion des factures, ...)"
                    }
                    price="75€/opérateur"
                  ></TogglePlanBrick>
                  <TogglePlanBrick
                    className=" border-l-3 border-indigo-300 border via-transparent to-transparent"
                    icon={
                      <div className="rounded-md bg-gradient-to-br from-indigo-500  to-indigo-200 p-0.5">
                        <Icon1
                          icon_name="smartphone"
                          fill="white"
                          size={22}
                        ></Icon1>
                      </div>
                    }
                    checked={["premium", "expert"].includes(
                      orgData.facturation.plan
                    )}
                    title="Fonctionnalités premium"
                    onChange={(checked) =>
                      userData.admin
                        ? handleChangePlan("premium", checked)
                        : setDisplayPlanMessage(true)
                    }
                    description={
                      "Accédez à l'application mobile hexagone (saisie de données terrain, photos), aux formulaires, aux rapports de contrôles et à l'assistance prioritaire."
                    }
                    price="75€/opérateur"
                  ></TogglePlanBrick>
                  <TogglePlanBrick
                    icon={
                      <div className="rounded-md bg-gradient-to-br from-cyan-500  to-cyan-200 p-0.5">
                        <Icon1 icon_name="brain" fill="white" size={22}></Icon1>
                      </div>
                    }
                    className=" border-l-3 border-cyan-300 border via-transparent to-transparent"
                    checked={orgData.facturation.plan === "expert"}
                    title="Fonctionnalités expert"
                    onChange={(checked) =>
                      userData.admin
                        ? handleChangePlan("expert", checked)
                        : setDisplayPlanMessage(true)
                    }
                    description={
                      "Accédez aux fonctionnalités d'intelligence artificielle (extraction automatique de données, génération de documents sur mesure (excel), lecture et traitement des emails, ...)"
                    }
                    price="70€/opérateur"
                  ></TogglePlanBrick>
                </div>
              </>
            )}

            {activeTab === "professions" && (
              <>
                <div>
                  <TogglePlanBrick
                    icon={<FolderTypeIcon type={"infiltro"} size={25} />}
                    title="Fonctionnalités INFILTRO"
                    checked={orgData.facturation.plans.includes("infiltro")}
                    onChange={(checked) =>
                      userData.admin
                        ? handleUpdatePlans("infiltro", checked)
                        : setDisplayPlanMessage(true)
                    }
                    description={
                      "Accédez à des fonctionnalités avancées liées au métier de l'infiltrométrie (prestations infiltrométrie, génération d'attestations isolants, carbone, rt batiment, lien infiltrea, lien obbc, ...)"
                    }
                    disabled={!userData.admin}
                  ></TogglePlanBrick>

                  <TogglePlanBrick
                    icon={<FolderTypeIcon type={"audit"} size={25} />}
                    icon_name="hexagone-audit"
                    title="Fonctionnalités AUDIT"
                    description={
                      "Accédez à des fonctionnalités avancées liées au métier de l'audit énergétique (prestations audit, lien obbc, en cours de développement, ...)"
                    }
                    onChange={(checked) =>
                      userData.admin
                        ? handleUpdatePlans("audit", checked)
                        : setDisplayPlanMessage(true)
                    }
                    checked={orgData.facturation.plans.includes("audit")}
                  ></TogglePlanBrick>
                </div>
              </>
            )}

            {activeTab === "factures" && (
              <>
                <div className="text-h1 text-black font-medium">Factures</div>
                {loadingData && <SmallSpinner></SmallSpinner>}
                <div className="flex flex-col gap-1 max-w-c900 w-full">
                  {factures_hexagone
                    .sort((a, b) => b.date - a.date)
                    .map((facture) => (
                      <div
                        key={facture.id}
                        className="flex flex-row gap-2 items-center  border-t-1 border-shadow_5 py-1"
                      >
                        <div className="text-h3 w-32 text-shadow_50 font-semibold">
                          {facture.type === "fees"
                            ? "Frais"
                            : facture.type === "subscription"
                              ? "Abonnement"
                              : "Achat de jetons"}
                        </div>
                        <div className="text-h3 w-c400 text-shadow_50">
                          {facture.name}
                        </div>
                        <div className="text-h3 w-40 text-shadow_50">
                          {getDateFromFlutter(facture.date).toLocaleString()}
                        </div>

                        <SecondaryButton
                          onClick={() => handleOpenFacture(facture)}
                          className="w-fit"
                          disabled={loadingOpenFacture}
                        >
                          Ouvrir
                          <SmallSpinner loading={loadingOpenFacture} />
                        </SecondaryButton>
                      </div>
                    ))}
                </div>
              </>
            )}
            {activeTab === "storage" && (
              <>
                <div className="text-h1 text-black font-medium">Stockage</div>
                <Space y={10} />
                <div className="text-h3 text-shadow_50">
                  Le stockage n'est pas limité.
                </div>
                <Space y={5} />
                <div className=" rounded-md py-0.5 text-shadow_50 bg-neutral-50 border-l-2 border-shadow_50 px-2 text-h2 font-semibold w-fit">
                  {formatSize(orgData.compteurs.storage)}
                </div>
              </>
            )}
            <Space y={50} />
          </>
        )}
      </div>
    </div>
  );
}

export default Facturation;
export function formatSize(octets) {
  if (octets < 1024) {
    return `${octets} octets`;
  } else if (octets < 1024 * 1024) {
    return `${(octets / 1024).toFixed(1)} KB`;
  } else if (octets < 1024 * 1024 * 1024) {
    return `${(octets / (1024 * 1024)).toFixed(1)} MB`;
  } else {
    return `${(octets / (1024 * 1024 * 1024)).toFixed(1)} GB`;
  }
}
